import { useState, useEffect } from 'react'
import { SortDirection as SortDirectionEnum } from '@/enums/sort-direction.enum'
import { ToolSortColumn } from '@/enums/tool-sort-column.enum'
import { ToolStatus } from '@/enums/tool-status.enum'
import { Pagination } from '@/components/ui'
import { useGetTools } from '@/hooks/useToolManagement/useGetTools'

import { ToolTable } from './ToolTable'

type StatusFilter = Nullable<ToolStatus>
type SortColumn = Nullable<ToolSortColumn>
type SortDirection = Nullable<SortDirectionEnum>

interface DrawerToolsTableProps {
  drawerId: StrOrNum
  searchTerm: string
  statusFilter: StatusFilter
  sortColumn: SortColumn
  sortDirection: SortDirection
  onSort: (column: SortColumn) => void
}

const ITEMS_PER_PAGE = 10

export function DrawerToolsTable({
  drawerId,
  searchTerm,
  statusFilter,
  sortColumn,
  sortDirection,
  onSort,
}: DrawerToolsTableProps) {
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    setCurrentPage(1)
  }, [drawerId, searchTerm, statusFilter, sortColumn, sortDirection])

  const {
    items: tools,
    total_pages,
    page,
  } = useGetTools(drawerId, {
    page: currentPage,
    page_size: ITEMS_PER_PAGE,
    search: searchTerm.trim().length >= 3 ? searchTerm.trim() : undefined,
    status: statusFilter ?? undefined,
    sort_by: sortColumn ?? undefined,
    sort_order: sortDirection ?? undefined,
  })

  useEffect(() => {
    if (page > total_pages && total_pages > 0) {
      setCurrentPage(1)
    }
  }, [total_pages, page])

  return (
    <div className='space-y-6'>
      <ToolTable
        tools={tools}
        sortColumn={sortColumn}
        sortDirection={sortDirection}
        onSort={onSort}
      />

      {total_pages > 1 && (
        <div className='flex justify-end'>
          <Pagination
            currentPage={page}
            totalPages={total_pages}
            onPageChange={setCurrentPage}
          />
        </div>
      )}
    </div>
  )
}
